module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-25.9b3d8215.png";